import { render, staticRenderFns } from "./Page-Registers.vue?vue&type=template&id=4df139c7&"
import script from "./Page-Registers.vue?vue&type=script&lang=js&"
export * from "./Page-Registers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports